import styled from 'styled-components';
import { Radio } from 'antd';

export const RadioButton = styled(Radio.Button)`
  &:hover {
    color: #1890ff !important;
  }

  &.ant-radio-button-wrapper-checked {
    background: #1890ff !important;

    &:hover {
      color: white !important;
    }
  }
`;
